export const environment = {
  production: true,
  tenant: {
    id: 'ndt',
    name: 'PPS'
  },
  externalCrm: true,
  rest: {
    apiUrl: 'rms.ndt-division.de',
    protocol: 'https',
    port: 443,
    basePath: '/v1',
    uploadBaseUrl: ''
  },
  auth: {
    apiUrl: 'auth.ndt-division.de',
    protocol: 'https',
    port: 443
  },
  crm: {
    apiUrl: 'pps.ndt-division.de/crmapi',
    protocol: 'https',
    port: 443
  },
  versions: {
    npm: '9.6.7',
    node: 'v18.17.1 (LTS)',
    clarity: '17.6'
  },
  stages: {
    name: ' UAT',
    dev: false
  }
};
